<div class="banner" role="banner">
  <h1>{{ 'pick.player.leaderboard.page.title' | translate }}</h1>
</div>
<div class="container">
  <div class="mt-3">
    <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
  </div>
</div>
